import { reportPageY } from '../../components/EditableGrid/utils/report-page-boundaries';
import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../../components/PageConfigProvider/constants';
import type { TabGrid } from '../../components/PageConfigProvider/page-reducer';
import type {
  Position,
  PositionedItem,
} from '../../components/PageConfigProvider/types/item';

type PageLocalItem = Omit<PositionedItem, 'id' | 'position'> & {
  id?: string;
  position: Partial<Position>;
};

export function buildReportPages(
  prefix: string,
  pages: PageLocalItem[][],
  startPage = 1
): {
  items: PositionedItem[];
  totalPages: number;
  grid: TabGrid;
} {
  const items: PositionedItem[] = [];
  pages.forEach((pageItems, pageArrayIndex) => {
    const gridPageNumber = startPage + pageArrayIndex;
    const pageBaseY = reportPageY(gridPageNumber);
    pageItems.forEach((localItem, itemIndex) => {
      const { id: explicitId, position, ...rest } = localItem;
      items.push({
        ...rest,
        id: explicitId ?? `${prefix}-p${gridPageNumber}-${itemIndex}`,
        position: {
          x: position.x ?? 0,
          y: pageBaseY + (position.y ?? 0),
          width: position.width ?? DEFAULT_GRID_COLUMNS,
          height: position.height ?? DEFAULT_GRID_ROWS,
        },
      });
    });
  });

  const footerPage = startPage + pages.length;
  const totalPages = footerPage + 1;
  return {
    items,
    totalPages,
    grid: {
      rows: DEFAULT_GRID_ROWS * totalPages,
      columns: DEFAULT_GRID_COLUMNS,
    },
  };
}
